import Vue from 'vue'
import VueRouter from 'vue-router'
import LightBootstrap from './light-bootstrap-main'
import {Message} from 'element-ui'
import {MessageBox} from 'element-ui'
import { Loading } from 'element-ui';

// Plugins
import App from './App.vue'
import {store} from './store/index'

// router setup
import routes from './routes/routes'
import Echo from 'laravel-echo'
import httpClient from "./api/httpClient";
window.Pusher = require('pusher-js');

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(Loading.directive);

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active'
})


/* Controle si droit de voir le dashboard direct */
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.loggedIn) {
            next({
                name: 'login',
            })
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.requiresVisitor)) {
        if (store.getters.loggedIn) {
            next({
                name: 'home',
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

Vue.mixin({
    methods: {
        $can(permissionName) {
            return store.state.auth.user.roles[0].permissions.find(o => o.name === permissionName) !== undefined
        },
        $hasRole(roleName) {
            return store.state.auth.user.roles.find(o => o.name === roleName) !== undefined
        },
    }
})

// 2021-04-20 09:39 to 20-04-2021 09:39
Vue.filter('nl2br', function(value) {
    if (value) {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }
});

Vue.filter('formatDate', function(value) {
    if (value) {

        const regex = /([0-9]{4})-([0-9]{2})-([0-9]{2})(.*)/gm;
        const str = value;
        const subst = `$3-$2-$1$4`;

        return str.replace(regex, subst);
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store: store,
    render: h => h(App),
    router: router,
    method:{
        addOrderToStore(order, beginning = false) {

            order.order_detail.forEach(detail => {

                store.commit('ps_order_detail/update_order_detail', detail)

                detail.todos.forEach(todo => {

                        store.commit('td_todo/update_todo', todo)

                        todo.comments.forEach(comment => {
                                store.commit('td_comment/update_comment', comment)
                            }
                        )

                    }
                )

            })

            store.commit('ps_orders/update_ps_order', {ps_order: order,beginning: beginning})

        }
    },

    created: function () {


        let warning_refresh = null;

        /*if ("Notification" in window) {
            var permission = Notification.permission;

            if (permission === "denied") {
                Notification.requestPermission();
            }
        }*/

        httpClient.interceptors.response.use(function (response) {
            return Promise.resolve(response);

        }, function (error) {

            store.commit('destroyToken')
            window.location.href = "/#/login";
        });

        // A modifier plus tard, merdique de charger cela ici
        this.$store.dispatch('td_action/get_td_action')
        this.$store.dispatch('td_status/get_td_status')
        this.$store.dispatch('retrieveMagasins')

        Pusher.logToConsole = false;
        let pusher = new Pusher('106bca209e0e2c4bcfb1', {
            cluster: 'eu'
        });


        pusher.subscribe('BikesCenterChannel')
            .bind('App\\Events\\NewTdTodo', e => {
                //if (e.todo.id_user != store.getters.get_auth_user_id)
                this.$options.method.addOrderToStore(e.ps_order)
            })
            .bind('App\\Events\\NewPsOrder', e => {
                this.$options.method.addOrderToStore(e.ps_order, true)
            })
            .bind('App\\Events\\DeleteTdTodo', function (e) {
                store.commit('td_todo/delete_todo', e.todo)
            })
            .bind('App\\Events\\UpdatePsOrder', function (e) {
                store.commit('ps_orders/update_ps_order', {ps_order : e.ps_order})
            })
            .bind('App\\Events\\UpdatePsOrderDetail', function (e) {
                store.commit('ps_order_detail/update_order_detail', e.ps_order_detail)
            })
            .bind("App\\Events\\UpdateTdTodo", function (e) {
                store.commit('td_todo/update_todo', e.todo)
            })
            .bind('App\\Events\\NewTdComment', function (e) {
                //if (e.comment.id_user != store.getters.get_auth_user_id)
                store.commit('td_comment/add_comment', e.comment)
            })
            .bind('App\\Events\\DeleteTdComment', function (e) {
                store.commit('td_comment/delete_td_comment', e.comment)
            })
            .bind('App\\Events\\UpdateTdComment', function (e) {
                store.commit('td_comment/update_comment', e.comment)
            })
            .bind('App\\Events\\NewReturnOrder', function (e) {
                //if (e.comment.id_user != store.getters.get_auth_user_id)
                store.commit('ps_order_return/add_ps_order_return', e.return)
            })
            .bind('App\\Events\\DeleteReturnOrder', function (e) {
                //if (e.comment.id_user != store.getters.get_auth_user_id)
                store.commit('ps_order_return/delete_ps_order_return', e.return)
            })


    }
})
